import I18n from 'I18n';
import { AVERAGE_TIME_BASED_GOALS, DEFAULT_GOAL_NAME } from '../constants/goals';
import { getIsAverageTimeBasedGoal } from './goal';
export const convertMillisecondsForTimeBasedGoalTargetAmount = timeLength => {
  const timeInMsFromHours = I18n.moment.duration(timeLength).asHours();
  return timeInMsFromHours.toFixed(2);
};
export const transformGoalTargetsData = (goalTarget, currency) => {
  const extractValue = property => {
    if (!property || !goalTarget.properties[property]) return null;
    return goalTarget.properties[property].value;
  };

  const MULTIPLE_VALUES_DELIMITER = ';';
  const goalType = extractValue('hs_goal_type');
  const adAccounts = extractValue('hs_ad_account_asset_ids');
  const adCampaigns = extractValue('hs_ad_campaign_asset_ids');
  const timeBasedGoalTargetAmountForDisplay = convertMillisecondsForTimeBasedGoalTargetAmount(Number(extractValue('hs_target_amount')));
  const goalTargetAmount = getIsAverageTimeBasedGoal(goalType) ? timeBasedGoalTargetAmountForDisplay : Number(extractValue('hs_target_amount'));
  return {
    objectId: goalTarget.objectId.toString(),
    assigneeType: extractValue('hs_participant_type'),
    contactLifecycleStage: extractValue('hs_contact_lifecycle_stage'),
    goalType,
    milestone: extractValue('hs_milestone'),
    status: extractValue('hs_status'),
    currency,
    goalTargetAmount,
    progress: Number(extractValue('hs_kpi_progress_percent')),
    startDatetime: Number(extractValue('hs_start_datetime')),
    endDatetime: Number(extractValue('hs_end_datetime')),
    fiscalYearOffset: Number(extractValue('hs_fiscal_year_offset')),
    kpiTrackingMethod: extractValue('hs_kpi_tracking_method'),
    kpiValue: Number(extractValue('hs_kpi_value')),
    kpiValueLastCalculatedAt: Number(extractValue('hs_kpi_value_last_calculated_at')),
    goalName: extractValue('hs_goal_name' || DEFAULT_GOAL_NAME),
    isEditable: Boolean(extractValue('isEditable')),
    adAccountAssetIds: adAccounts ? new Set(adAccounts.split(MULTIPLE_VALUES_DELIMITER)) : undefined,
    adCampaignAssetIds: adCampaigns ? new Set(adCampaigns.split(MULTIPLE_VALUES_DELIMITER)) : undefined
  };
};
export const getGoalTargets = (data, currency) => {
  if (!data || !data.results) return [];
  return Object.values(data.results).reduce((goalTargetAcc, goalTarget) => {
    if (!goalTarget || !goalTarget.objectId) return null;
    goalTargetAcc.push(transformGoalTargetsData(goalTarget, currency));
    return goalTargetAcc;
  }, new Array());
};
export const addAdCampaignsToGoalTargets = (goalTargets, adCampaigns) => {
  const goalTargetsWithAdCampaigns = new Array();
  goalTargets.forEach(goalTarget => {
    const campaigns = new Array();
    adCampaigns.forEach(adCampaign => {
      if (goalTarget.adCampaignAssetIds && goalTarget.adCampaignAssetIds.has(adCampaign.adCampaignAssetId)) {
        campaigns.push(adCampaign);
      }
    });
    goalTargetsWithAdCampaigns.push(Object.assign({}, goalTarget, {
      adCampaigns: campaigns
    }));
  });
  return goalTargetsWithAdCampaigns;
};
export const getIsKpiValueBasedGoalTarget = goalType => {
  if (AVERAGE_TIME_BASED_GOALS.includes(goalType)) {
    return true;
  }

  return false;
};
export const getGoalTargetsWithPermissions = (targets, goalTargetPermissions) => {
  if (!targets) return [];
  const targetsWithPermissions = targets.map(target => {
    const permissionForTarget = goalTargetPermissions.find(item => item.goalTargetId.toString() === target.objectId);
    target.isEditable = Boolean(permissionForTarget && permissionForTarget.isEditable);
    return target;
  });
  return targetsWithPermissions;
};